export default __webpack_public_path__ + "12dba8b7e11f24af93fcaacc1d7d9762.svg";